import { render, staticRenderFns } from "./theme-4.vue?vue&type=template&id=666391de"
import script from "./theme-4.vue?vue&type=script&lang=js"
export * from "./theme-4.vue?vue&type=script&lang=js"
import style0 from "./theme-4.vue?vue&type=style&index=0&id=666391de&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsDownloadBanner: require('/app/components/Commons/DownloadBanner.vue').default,CommonsMaintenance: require('/app/components/Commons/Maintenance.vue').default,CommonsChangeLanguageLoading: require('/app/components/Commons/ChangeLanguageLoading.vue').default,Theme4ConfirmDepositDialog: require('/app/components/Theme4/ConfirmDepositDialog.vue').default,Theme4WithdrawalConfirmDeclineDialog: require('/app/components/Theme4/WithdrawalConfirmDeclineDialog.vue').default,Theme4FloatingIcon1: require('/app/components/Theme4/FloatingIcon1.vue').default,Theme4FloatingIcon2: require('/app/components/Theme4/FloatingIcon2.vue').default,Theme4AgentFloatingIcon: require('/app/components/Theme4/AgentFloatingIcon.vue').default,Theme4ExchangeRatePopup: require('/app/components/Theme4/ExchangeRatePopup.vue').default,Theme4OfflinePage: require('/app/components/Theme4/OfflinePage.vue').default,Theme4Footer: require('/app/components/Theme4/Footer.vue').default,Theme4ImageBackground: require('/app/components/Theme4/ImageBackground.vue').default,Theme4MobileFooterMenu: require('/app/components/Theme4/Mobile/FooterMenu.vue').default,Theme4HoldBalanceDialog: require('/app/components/Theme4/HoldBalanceDialog.vue').default,CommonsThemeMode: require('/app/components/Commons/ThemeMode.vue').default})
